export const content_sv_SE_SKBV = {
  tacLabel:
    'Jag samtycker till att Skånska Byggvaror samlar in och använder mina kontaktuppgifter i enlighet med GDPR.',
  tacError: 'Du måste kryssa i denna',
  submitButton: 'Skicka',
  imageAlt: 'Formulärbild',
  formNotFound: 'Vi hittade dessvärre inget formulär.',
  formNotStarted: 'Formuläret är inte tillgängligt än.',
  formExpired: 'Formuläret är inte längre tillgängligt.',
  soonForwarded: 'Du kommer snart skickas vidare till',
  contactDetails: 'Kontaktuppgifter',
  loading: 'Laddar formulär',
  posting: 'Postar svar',
  previewing: 'Förhandsgranskar',
  errors: {
    'Forbidden - XSS warning':
      'Hej hopp! Gick det lite snabbt på tangentbordet? Kontrollera så att inga konstiga krumelurer tex "<" eller ">" har smugit sig in in i ditt svar och prova igen!',
    noFormUID: 'Formulär-ID saknas',
    noData: 'Formulärdata saknas eller är ogiltigt',
  },
  contactLabels: {
    heading: 'Kontaktuppgifter',
    name: 'Fullständigt namn',
    address: 'Gatuadress',
    city: 'Postort',
    postalCode: 'Postnummer',
    phone: 'Telefonnummer',
    email: 'E-post',
  },
  countryCode: '+46 ',
  errorMessages: {
    name: {
      tooLong: 'Ditt namn innehåller för många tecken.',
    },
    address: {
      tooLong: 'Din address innehåller för många tecken.',
    },
    postalCode: {
      tooLong: 'Din postkod innehåller för många tecken.',
    },
    city: {
      tooLong: 'Din postort innehåller för många tecken.',
    },
    phone: {
      invalid: 'Vänligen ange ett korrekt telefonnummer',
      tooShort: 'Ditt telefonnummer innehåller för få tecken',
      tooLong: 'Ditt telefonnummer innehåller för många tecken.',
    },
    email: {
      invalid: 'Vänligen ange en korrekt e-postadress',
      tooLong: 'Din e-postadress innehåller för många tecken.',
    },
  },
};
